export default "__VITE_ASSET__CjTBEKSx__"